import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap');
    
    button, .highlight {
        font-weight: 500;
    }

    body {
        font-family: 'Poppins', 'Inter', sans-serif;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    h1, h2, h3 {
        letter-spacing: 0.5px;
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: 'Poppins', 'Inter', sans-serif;
        font-weight: 700; // Bold per titoli
    }

    p, a, button, input, textarea {
        font-family: 'Poppins', 'Inter', sans-serif;
        font-weight: 400; // Regular per testi
    }

    // Regola dimensioni font su mobile
    @media (max-width: 768px) {
        h1 {
            font-size: 1.8rem;
        }

        h2 {
            font-size: 1.5rem;
        }

        h3 {
            font-size: 1.2rem;
        }

        p, a, button, input, textarea {
            font-size: 0.9rem;
        }
    }
`;

export default GlobalStyle;
